import { DetailCard } from '#components/atoms/cards/detail-card/DetailCard.tsx';

export function ConnectWithUs() {
  return (
    <DetailCard>
      <h2 className="h6">Connect with us</h2>
      <p className="p-md">Keep in touch with us on social media for the latest news about our company.</p>
      <ul className="ul-md">
        <li>
          <a className="a" href="https://bsky.app/profile/defined.net">
            Follow us on Bluesky
          </a>
        </li>
        <li>
          <a className="a" href="https://www.linkedin.com/company/definednet/">
            Follow us on LinkedIn
          </a>
        </li>
      </ul>
    </DetailCard>
  );
}
